<script>

    import * as echarts from 'echarts'
    import { onMount } from 'svelte'

    import GraphicsService from '../$services/graphics.service'

    export let dateStart = null
    export let dateEnd = null

    const COLORS = {
        'Guías generadas': '#22c55e',
        'Entregadas': '#3b82f6',
        'Canceladas': '#ef4444',
    }

    let chartContainer
    let chart
    let ready = false

    onMount(() => {
        chart = echarts.init(chartContainer)
        ready = true

        const resize = () => chart.resize()
        window.addEventListener('resize', resize)

        return () => {
            window.removeEventListener('resize', resize)
            chart.dispose()
            chart = null
            ready = false
        }
    })

    $: if (ready) load(dateStart, dateEnd)

    async function load(start, end) {
        if (!chart || !start || !end) return

        const res = await GraphicsService.getShipmentsEvolution({
            dateStart: start.toISOString(),
            dateEnd: end.toISOString(),
        })

        const data = res?.data ?? res
        if (!data?.labels || !data?.datasets) return

        chart.setOption({
            color: data.datasets.map((ds) => COLORS[ds.label] || '#9ca3af'),
            tooltip: {
                trigger: 'axis',
            },
            legend: {
                top: 0,
                right: 0,
                icon: 'circle',
                itemWidth: 8,
                itemHeight: 8,
                textStyle: {
                    color: '#6b7280',
                    fontSize: 12,
                },
            },
            grid: {
                left: 8,
                right: 8,
                top: 40,
                bottom: 8,
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: data.labels,
                axisLine: { lineStyle: { color: '#e5e7eb' } },
                axisTick: { show: false },
                axisLabel: { color: '#9ca3af', fontSize: 11 },
            },
            yAxis: {
                type: 'value',
                splitLine: { lineStyle: { color: '#f3f4f6' } },
                axisLabel: { color: '#9ca3af', fontSize: 11 },
            },
            series: data.datasets.map((ds) => ({
                name: ds.label,
                type: 'line',
                smooth: true,
                symbol: 'circle',
                symbolSize: 11,
                showSymbol: true,
                lineStyle: { width: 2.5 },
                itemStyle: { borderWidth: 2, borderColor: '#fff' },
                data: ds.data,
            })),
        }, true)
    }

</script>

<style>
    .graphic-card {
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
        padding: 1.35rem 1.5rem;
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .header {
        display: flex;
        align-items: center;
        gap: 0.65rem;
        margin-bottom: 1rem;
    }

    .icon {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: #e8f8ef;
        color: #22c55e;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.9rem;
        flex-shrink: 0;
    }

    .title {
        font-size: 1.05rem;
        font-weight: 700;
        color: #1a1a1a;
        margin: 0;
        line-height: 1.2;
    }

    .chart {
        width: 100%;
        height: 320px;
    }
</style>

<div class="graphic-card">
    <div class="header">
        <div class="icon">
            <i class="fas fa-chart-area"></i>
        </div>
        <h3 class="title">Evolución de envíos</h3>
    </div>

    <div bind:this={chartContainer} class="chart"></div>
</div>
